import React from 'react';

import Icon from '../../../../_ui/_blocks/Icon/Icon';

interface Props {
    reasons: Array<{
        _key: string;
        content: string;
    }>;
    className?: string;
}

const ReasonsToBuy = ({ reasons, className }: Props) => (
    <ul className={`space-y-050 ${className || ''}`}>
        {reasons?.map((reason) => (
            <li key={reason._key} className="flex gap-050 type-090">
                <Icon icon="stamp-light" alt="tick" />
                {reason.content}
            </li>
        ))}
    </ul>
);

export default ReasonsToBuy;
